import type { Testimonial } from '../types/content';
export const stats = [['3', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Valentina P.',
  place: 'Buenos Aires',
  quote: 'Había leído muchos consejos sobre autoestima, pero nunca sabía qué hacer primero. Con el plan de siete días tengo una actividad concreta para cada jornada.'
}, {
  name: 'Daniela M.',
  place: 'Córdoba',
  quote: 'Me costaba muchísimo decir que no. Lo que más me gustó fue encontrar conversaciones y respuestas preparadas para situaciones que vivo con mi familia.'
}, {
  name: 'Camila S.',
  place: 'Rosario',
  quote: 'Muchas veces reaccionaba por miedo a decepcionar. Los ejemplos me ayudan a reconocer esas situaciones y encontrar otras formas de responder.'
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Luciana R.',
  place: 'Mendoza',
  quote: 'Siempre me sentía culpable cuando necesitaba tiempo para mí. Me sirvió encontrar frases y ejemplos específicos para esos momentos.'
}, {
  name: 'Gabriela T.',
  place: 'La Plata',
  quote: 'Me exijo mucho y suelo darle vueltas a mis errores. Los protocolos me ofrecen pasos concretos para mirar esas situaciones de otra manera.'
}, {
  name: 'Ivana N.',
  place: 'Neuquén',
  quote: 'Pensaba que necesitaba dedicarle mucho tiempo al autocuidado. Las pausas de cinco minutos son fáciles de incorporar entre mis actividades.'
}, {
  name: 'Brenda A.',
  place: 'Mar del Plata',
  quote: 'Antes abandonaba una rutina y después no sabía cómo retomarla. Tener planes de reinicio preparados me resulta mucho más práctico.'
}];
